import React, {Component} from 'react'
import {v1 as uuidv1} from 'uuid'

import OnlineCounter from '../OnlineCounter'

import style from './resultRatingList.module.scss'
import Assets from '../../../../../core/utils/Assets'

class ResultRatingList extends Component {

   render() {
      const {data} = this.props
      return (
         <ul className={style.resultRatingList__ratingList}>
            <li className={style.resultRatingList__ratingItem} key={uuidv1()}>
               <OnlineCounter online={data.online} />
               <span className={style.resultRatingList__ratingText}>GIRLS ONLINE</span>
            </li>
            <li className={style.resultRatingList__ratingItem} key={uuidv1()}>
               <b className={style.resultRatingList__ratingNumber}>{data.replyRate}%</b>
               <span className={style.resultRatingList__ratingText}>REPLY RATE</span>
            </li>
            <li className={style.resultRatingList__ratingItem} key={uuidv1()}>
               <b className={style.resultRatingList__ratingNumber}>
                  <img src={Assets.getImage(`quiz/star_active.png`)} />
                  {data.rating}
               </b>
               <span className={style.resultRatingList__ratingText}>RATING</span>
            </li>
         </ul>
      )
   }
}

export default ResultRatingList